var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepartmentFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_106498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 4.22266C12.9289 4.22266 11.25 5.90159 11.25 7.97266C11.25 9.60543 12.2935 10.9945 13.75 11.5093V14.2227H10C7.92894 14.2227 6.25 15.9015 6.25 17.9727V19.436C4.79351 19.9508 3.75 21.3399 3.75 22.9727C3.75 25.0438 5.42894 26.7227 7.5 26.7227C9.57106 26.7227 11.25 25.0438 11.25 22.9727C11.25 21.3399 10.2065 19.9508 8.75 19.436V17.9727C8.75 17.2823 9.30965 16.7227 10 16.7227H20C20.6904 16.7227 21.25 17.2823 21.25 17.9727V19.436C19.7935 19.9508 18.75 21.3399 18.75 22.9727C18.75 25.0438 20.4289 26.7227 22.5 26.7227C24.5711 26.7227 26.25 25.0438 26.25 22.9727C26.25 21.3399 25.2065 19.9508 23.75 19.436V17.9727C23.75 15.9015 22.0711 14.2227 20 14.2227H16.25V11.5093C17.7065 10.9945 18.75 9.60543 18.75 7.97266C18.75 5.90159 17.0711 4.22266 15 4.22266Z",
    fill: "#09244B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_106498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.472656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentFilter);
export default __webpack_public_path__ + "static/media/departmentFilter.9f481292304a97656a7ce96092f5d37b.svg";
export { ForwardRef as ReactComponent };